import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { StoreButton } from "@/components/Buttons";
import { useKeepStore } from "@/components/layout/Crumbs";

/**
 * The thin signs365-style banner across the top of the home page. The shop uploads a wide photo in
 * Branding; until then a bold placeholder in the shop's colors hangs there.
 */
export function HeroBanner({ card, theme }) {
    const keep = useKeepStore();
    const name = card?.name || "13thav";
    const bg = card?.banner ? mediaUrl(card.banner) : null;
    const accent = theme?.primary || "#2563EB";
    const tagline = card?.tagline || `${name} prints it. Same-day white tees, signs and flyers.`;
    return (
        <section className="dark-block relative overflow-hidden bg-[#0b0b0b] text-white" data-testid="hero-banner" data-placeholder={bg ? "false" : "true"}>
            {bg ? (
                <img src={bg} alt="" className="absolute inset-0 h-full w-full object-cover" data-testid="hero-banner-image" />
            ) : (
                <div className="absolute inset-0" aria-hidden="true"
                    style={{ background: `repeating-linear-gradient(135deg, ${accent} 0 18px, transparent 18px 44px)`, opacity: 0.18 }} />
            )}
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/20" />
            <div className="relative mx-auto flex max-w-7xl flex-col gap-5 px-4 py-8 sm:px-6 md:flex-row md:items-end md:justify-between md:py-10">
                <div className="min-w-0">
                    <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/70" data-testid="hero-kicker">
                        {[card?.city, "Order online", "pick up or ship"].filter(Boolean).join(" · ")}
                    </p>
                    <h1 className="mt-2 max-w-3xl font-display text-3xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="hero-title">
                        {tagline}
                    </h1>
                </div>
                <div className="flex shrink-0 flex-wrap gap-2">
                    <Link to={keep("/shirts")} data-testid="hero-cta-shirts"><StoreButton theme={theme} className="px-5 py-3 text-xs">Order shirts <ArrowRight size={14} /></StoreButton></Link>
                    <Link to={keep("/signs")} data-testid="hero-cta-signs"
                        className="inline-flex items-center gap-2 border-2 border-white px-5 py-3 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-white hover:text-black">
                        Order signs <ArrowRight size={14} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
